<template>
  <div class="text-body-m">
    <div
      v-for="(features, categoryName) in groupedFeaturesByCategory"
      :key="categoryName"
      class="pb-8 text-body-m-bold"
      :data-testid="`agency-feature-category-${categoryName}`"
    >
      {{ categoryName }}
      <div class="flex flex-wrap pt-4">
        <div v-for="feature in features" :key="feature" class="pr-8 pb-4 text-body-m">
          <div class="flex">
            <CheckIcon />
            <span class="pl-2">{{ feature }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { CheckIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'

import type { AgencyData } from '@/gql/reviews'

const props = defineProps<{
  assignedFeatures: AgencyData['assignedFeatures']
}>()

const groupedFeaturesByCategory = computed(() => {
  const grouped: Record<string, string[]> = {}
  props.assignedFeatures.forEach((assignedFeature) => {
    const categoryTitle = assignedFeature.feature.category?.title
    if (categoryTitle) {
      if (!grouped[categoryTitle]) {
        grouped[categoryTitle] = []
      }
      grouped[categoryTitle].push(assignedFeature.feature.name)
    }
  })
  return grouped
})
</script>
